import degreesToDirection from 'degrees-to-direction';
import React from 'react';

interface ConeLabelsProps {
    innerEdge: number;
    outerEdge: number;
    coneCount: number;
    fontSize: number;
}

const ConeLabels = ({ innerEdge, outerEdge, coneCount, fontSize }: ConeLabelsProps) => (
    <g>
        {Array.from({ length: coneCount }).map((_, i) => {
            const angle = (i / coneCount) * 360;

            return (
                <g key={i}>
                    <polyline
                        points={`0,-${innerEdge} 0,-${outerEdge}`}
                        stroke='#16161d'
                        fill='none'
                        opacity='0.5'
                        strokeDasharray='10,10'
                        transform={`rotate(${angle})`}
                    />
                    <text
                        fill='currentColor'
                        textAnchor='middle'
                        transform={`rotate(${angle})translate(0, ${-outerEdge - 10})`}
                        style={{ fontSize: `${fontSize}%` }}
                    >
                        {degreesToDirection(angle)}
                    </text>
                </g>
            );
        })}
    </g>
);

export default ConeLabels;
